import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

function OverflowTitleTooltip({ title, children }) {
  const [overflow, setOverflow] = useState(false);

  const wrapper = useRef(null);

  const checkOverflow = useCallback(() => {
    const element = wrapper.current.children[0];

    const overflowLocal = element.clientWidth < element.scrollWidth;
    if (overflowLocal !== overflow) {
      setOverflow(overflowLocal);
    }
  }, [overflow]);

  useEffect(() => {
    checkOverflow();
  }, [checkOverflow]);

  let childProps = {};
  if (overflow) {
    childProps.title = title;
  }
  return <div ref={wrapper}>{React.cloneElement(React.Children.only(children), childProps)} </div>;
}

OverflowTitleTooltip.displayName = 'OverflowTooltip';
OverflowTitleTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default OverflowTitleTooltip;
